// OUTNodesMultiSelect.tsx
import {useState} from "react";
import * as React from "react";
import "./index.css"
import Select from 'react-select'

const OUTNodesMultiSelect = ({ outdir, onChange }: any) => {
  const [selected, setSelected] = useState<string[]>([])
  const [options, setOptions] = useState<{}[]>([])

  // If the model changes, then 
  // the displayed value must also change
  // Adjust for cases where val is null.
  React.useEffect(() => {
    setSelected([])

    if(outdir?.objects?.NODE?.items){
      Object.keys(outdir?.objects?.NODE?.items).forEach((el:string) =>{
        setOptions(oldState => [...oldState, { value: el, label: outdir?.objects?.NODE?.items[el]}])
      })
    }
  }, [outdir])

  const handleChange = (option:any) => {
    let results = option.map((val:any) =>{
      return val.label
    })
    
    onChange({name: 'objNames', value: results})
  }

  return (
    <Select options={options} onChange={handleChange} styles={{menuPortal: base => ({zIndex:0}) }} isMulti/>
  )
}

export {OUTNodesMultiSelect};